import {io, Socket} from 'socket.io-client'
import {BACKEND_URL, SOCKET_URL} from '../../constants/apiConstants'
import {queryClient} from '../../queryClient'
import {formatDetails} from '../dialogApi'
import type {IFlaggedResponses} from '../../types/dialogTypes'

export let socket: Socket | null = null

const getDialogRefreshEventName = (dialogId: string): string =>
  `refresh:${dialogId}`

const getModerationEventName = (dialogId: string): string =>
  `moderation:${dialogId}`

export const initiateConversationSocketConnection = (
  dialogId?: string,
): void => {
  const normalizedDialogId = dialogId?.trim()
  if (!normalizedDialogId) {
    return
  }

  socket = io(SOCKET_URL || BACKEND_URL, {
    path: '/conversation',
    forceNew: true,
    reconnectionAttempts: 3,
    timeout: 2000,
    transports: ['websocket'],
  })

  socket.on(
    getDialogRefreshEventName(normalizedDialogId),
    (data: Parameters<typeof formatDetails>[0]) => {
      const formatted = formatDetails(data)
      queryClient.setQueryData(['dialog', normalizedDialogId], formatted)
      if (formatted.analytics) {
        queryClient.setQueryData(
          ['dialog', normalizedDialogId, 'analytics'],
          formatted.analytics,
        )
      }
    },
  )
  socket.on(
    getModerationEventName(normalizedDialogId),
    (data: IFlaggedResponses) => {
      queryClient.setQueryData(['dialog', normalizedDialogId, 'flagged'], data)
    },
  )
}

export const disconnectConversationSocket = (): void => {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
